import partnerClient from './partnerClient';

export const registerPartnerUser = async (payload) => {
  const response = await partnerClient.post('/partner-auth/register', payload);
  return response.data;
};

export const partnerLogin = async ({ email, password }) => {
  const response = await partnerClient.post('/partner-auth/login', { email, password });
  return response.data;
};

export const getPartnerSession = async () => {
  const response = await partnerClient.get('/partner-auth/me');
  return response.data;
};

export const getPartnerProfile = async () => {
  const response = await partnerClient.get('/manufacturing-partners/profile');
  return response.data.profile;
};

export const updatePartnerProfile = async (payload) => {
  const response = await partnerClient.patch('/manufacturing-partners/profile', payload);
  return response.data.profile;
};

export const getPartnerDashboard = async () => {
  const response = await partnerClient.get('/manufacturing-partners/dashboard');
  return response.data;
};

export const getManufacturingQueue = async () => {
  const response = await partnerClient.get('/orders/manufacturing-queue');
  return response.data;
};

export const getOrderStatus = async (orderId) => {
  const response = await partnerClient.get(`/orders/status/${orderId}`);
  return response.data;
};

export const updateOrderProductionStatus = async (orderId, payload) => {
  const response = await partnerClient.post(
    `/orders/update-production-status/${orderId}`,
    payload
  );
  return response.data;
};

export const downloadOrderTechPack = async (orderId) => {
  const response = await partnerClient.get(`/orders/download-techpack/${orderId}`, {
    responseType: 'blob',
  });
  return response;
};

export const listPartnerRfqs = async (params = {}) => {
  const response = await partnerClient.get('/partner-rfqs', { params });
  return response.data;
};

export const getPartnerRfq = async (rfqId) => {
  const response = await partnerClient.get(`/partner-rfqs/${rfqId}`);
  return response.data;
};

export const respondToPartnerRfq = async (rfqId, payload) => {
  const response = await partnerClient.post(`/partner-rfqs/${rfqId}/respond`, payload);
  return response.data;
};

export const downloadPartnerTechpack = async (rfqId) => {
  const response = await partnerClient.get(`/partner-rfqs/${rfqId}/download-techpack`, {
    responseType: 'blob',
  });
  return response;
};

export const listPartnerApiKeys = async () => {
  const response = await partnerClient.get('/partner-auth/api-keys');
  return response.data.apiKeys;
};

export const createPartnerApiKey = async (payload = {}) => {
  const response = await partnerClient.post('/partner-auth/api-keys', payload);
  return response.data;
};

export const deletePartnerApiKey = async ({ tokenId, tokenHash }) => {
  const response = await partnerClient.delete(`/partner-auth/api-keys/${tokenId}`, {
    data: tokenHash ? { tokenHash } : undefined,
  });
  return response.data;
};
